/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CmisProperty } from './cmisProperty';


export interface CmisPropertiesType { 
    property?: Array<CmisProperty>;
    any?: Array<object>;
    otherAttributes?: { [key: string]: string; };
}

